import type { PatientNotesBlock } from '../../../../services/patientCard';
import { Card, NoteBlock } from '../shared';

interface MondayNotesCardProps {
    notes: PatientNotesBlock | undefined;
}

function MondayNotesCard({ notes }: MondayNotesCardProps) {
    if (!notes?.treatmentGoals && !notes?.doctorGoals && !notes?.dmNotes) return null;

    return (
        <Card title="Notes" maxHeight="max-h-[420px]">
            <div className="flex flex-col gap-3 overflow-y-auto scrollbar-hide min-h-0 flex-1">
                {notes?.treatmentGoals && (
                    <NoteBlock label="Treatment goals" value={notes.treatmentGoals} />
                )}
                {notes?.doctorGoals && <NoteBlock label="Doctor goals" value={notes.doctorGoals} />}
                {notes?.dmNotes && <NoteBlock label="DM notes" value={notes.dmNotes} />}
            </div>
        </Card>
    );
}

export { MondayNotesCard };
